import { Badge } from '@/components/ui/Badge'
import { EmptyState } from '@/components/ui/EmptyState'
import type { DashboardNoticeItemViewModel } from '@/lib/venue/dashboardViewModel'

/** 운영 공지 발송 현황 — 대시보드 EP 의 최근 N건(#590 §5, 최대 3건). */
export function DashboardNoticeList({ items }: { items: DashboardNoticeItemViewModel[] }) {
  if (items.length === 0) {
    return <EmptyState title="발송한 공지가 없습니다" description="공지·홍보 관리에서 새 공지를 발송할 수 있습니다." />
  }

  return (
    <ul className="divide-y divide-slateish-200">
      {items.map((item) => (
        <li key={item.key} className="flex items-center justify-between gap-3 py-3 text-sm">
          <div className="min-w-0">
            <p className="truncate font-medium text-ink-700">{item.title}</p>
            <p className="mt-0.5 text-xs text-slateish-600">{item.dateText}</p>
          </div>
          <Badge tone={item.tone}>{item.statusLabel}</Badge>
        </li>
      ))}
    </ul>
  )
}
